export async function mpost(url, data = {}) {
  const response = await fetch(url, {
    method: "POST",
    headers: new Headers(),
    body: toFormData(data),
  })
    .then((response) => response.text())
    .then((response) => {
      if (response.startsWith("<!DOCTYPE")) return { status: 404, error: "Connection Error" };
      response = JSON.parse(response);
      if (response.status === 200) return response.data;
      return {
        status: response.status ?? 500,
        error: response.message ?? "Invalid Response",
        data: response.data,
        error_code: response.error_code,
      };
    })
    .catch((err) => {
      return { error: "An error has occur", status: 500 };
    });
  return response;
}

export function toFormData(obj) {
  let formData = new FormData();
  Object.keys(obj).map((key) => formData.append(key, obj[key]));
  return formData;
}
